"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = debounce;
function debounce(func, delay) {
  var timeout = void 0;

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var later = function later() {
      timeout = null;
      func.apply(null, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, delay);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-form/lib/utils/debounce.js
// module id = 985
// module chunks = 0